const Cross = ({ ...props }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M1 1L18.9996 18.9996" stroke="#080807" strokeWidth="2" />
            <path d="M19 1L1.0004 18.9996" stroke="#080807" strokeWidth="2" />
        </svg>
    )
}

export default Cross
